import * as React from 'react';
import page404 from '../assets/img/page-not-found.png';
import { SEO } from '../layout/SEO';
import './404.scss';
import { helixAnalytics } from '../shared/analytics/HelixAnalytics';

export default function Page404({ path }: { path?: string }) {
    React.useEffect(() => {
        helixAnalytics.trackPageView(`404 Not Found`, `Error`);
    }, []);
    return (
        <div className="page-not-found">
            <h1 className="typestack-title-1">404 Error</h1>
            <p className="typestack-body-1">
                We're sorry, it looks like the page you're trying to find has
                been moved or deleted.
            </p>
            <img src={page404} alt="404 Error" />
        </div>
    );
}

export const Head = ({ location, params, data, pageContext }) => (
    <SEO
        location="/404"
        title="Page Not Found"
        description="We're sorry, it looks like the page you're trying to find has been moved or deleted."
    />
);
